import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level cache: fetch /api/reviews ONCE per page load, share across components.
let _cache = null;
let _inflight = null;

function fetchOnce() {
  if (_cache) return Promise.resolve(_cache);
  if (_inflight) return _inflight;
  _inflight = axios
    .get(`${API}/reviews`)
    .then((r) => {
      _cache = r.data;
      _inflight = null;
      return _cache;
    })
    .catch((e) => {
      _inflight = null;
      throw e;
    });
  return _inflight;
}

export function useReviews() {
  const [data, setData] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    let active = true;
    if (_cache) {
      setData(_cache);
      setLoading(false);
      return () => {};
    }
    fetchOnce()
      .then((d) => active && setData(d))
      .catch(() => active && setData(null))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  const live =
    data &&
    data.configured &&
    Array.isArray(data.reviews) &&
    data.reviews.length > 0;

  return {
    loading,
    live,
    rating: live ? data.rating : null,
    ratingCount: live ? data.user_rating_count : null,
    mapsUri: live
      ? data.google_maps_uri
      : "https://www.google.com/maps/search/?api=1&query=ScootiveCamp",
    reviews: live ? data.reviews : [],
    name: live ? data.name : null,
  };
}
